import React, { useContext, useEffect } from 'react';
import { Col, Image, Row } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CommonToast from 'components/commom/CommonToast';
import { ClearTokenRedirectLogin } from 'utils/general';
import skinAnalyser from 'assets/images/Enterprise/faceDetection.png';
import skinConcern from 'assets/images/Enterprise/footInfection.png';
import hairAnalyser from 'assets/images/Enterprise/hairLogo.png';
import LeadCapture from 'Pages/Admin/LeadCapture';
import { leadCaptureDropdownCallAPI } from 'store/LeadCapture/leadCaptureDropdown/action';

const EnterpriseDashboard = () => {
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();

  const enterpriseData = useSelector(
    (state) => state?.getEnterpriseProfileReducer?.users?.data
  );

  const numberData = [
    {
      id: 1,
      name: 'Skin Analysis',
      img: skinAnalyser,
      cardcolor: '#E8EBE4',
      btncolor: '#375241',
    },
    {
      id: 2,
      name: 'SkinConcern Identifier',
      img: skinConcern,
      cardcolor: '#FAF1EC',
      btncolor: '#864626',
    },
    {
      id: 3,
      name: 'Hair Analyser',
      img: hairAnalyser,
      cardcolor: '#E8EBE4',
      btncolor: '#375241',
    },
  ];

  useEffect(() => {
    if (enterpriseData && enterpriseData?.enterprise?.is_internal) {
      dispatch(
        leadCaptureDropdownCallAPI({
          run: true,
          handleFunction: () => {},
          authorize: true,
          handleAuthorizeFunction: (res) => {
            ClearTokenRedirectLogin(navigate);
          },
          error: true,
          handleErrorFunction: (res) => {
            showToast(res?.message, 'error');
          },
        })
      );
    }
  }, [enterpriseData]);

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <div className="d-flex justify-between">
            <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600 lh-4032  m-0">
              Dashboard
            </h2>
          </div>
          <div className="mt-[70px] grid md:grid-cols-2 2xl:grid-cols-3 gap-[20px]">
            {numberData &&
              numberData?.map((item, idx) => (
                <div className="flex items-stretch pt-[20px]" key={idx}>
                  <div
                    className="relative rounded-[26px] overflow-visible flex flex-col w-full border-1 border-[#ABAEB1]"
                    style={{ backgroundColor: item?.cardcolor }}
                    onClick={() => {
                      // handleViewAnalysis(item);
                    }}
                  >
                    <div
                      className="absolute right-[16px]"
                      style={{
                        top: item?.id === 1 ? -70 : item?.id === 2 ? -100 : -50,
                        zIndex: 1,
                      }}
                    >
                      <Image
                        src={item?.img}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </div>

                    <div className="p-[16px]">
                      <div
                        className="text-[24px] font-[500] italic"
                        style={{ fontFamily: 'AktivGrotesk-Medium' }}
                      >
                        {item?.name}
                      </div>
                      <div
                        className="text-[70px] font-[400] mt-[20px]"
                        style={{
                          color: item?.btncolor,
                          fontFamily: 'RampartOne-Regular',
                        }}
                      >
                        {item?.id === 1
                          ? enterpriseData?.skin_analyser_count
                          : item?.id === 2
                            ? enterpriseData?.skin_concern_identifier_count
                            : item?.id === 3
                              ? enterpriseData?.hair_analyser_count
                              : ''}
                      </div>
                    </div>
                    <div className="flex-1" />
                    {/* <div
                      className="py-[20px] w-full text-center cursor-pointer rounded-b-[26px]"
                      style={{ backgroundColor: item?.btncolor }}
                    >
                      <div className="text-[20px] text-white family_outfit_regular_400 lh-176">
                        View All
                      </div>
                    </div> */}
                  </div>
                </div>
              ))}
          </div>
          {enterpriseData?.enterprise?.is_internal && (
            <div className="mt-[30px]">
              <LeadCapture />
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default EnterpriseDashboard;
